<h2 mat-dialog-title>
    {{ title }}
    <button mat-icon-button class="close-button" [mat-dialog-close]="dirty">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<div mat-dialog-content class="scroll-content">
    <ng-content></ng-content>
</div>

<div *ngIf="!isSaveButton && !isEdit && isSupportEdit && actionRole.can_update">
    <eig-details-modal-action (goToEdit)="onSwitchToEditPage()"></eig-details-modal-action>
</div>

<div mat-dialog-actions *ngIf="isSaveButton">
    <button mat-raised-button color="primary" (click)="onSave()">
        <mat-icon>save</mat-icon>
        <span *ngIf="isEdit" class="hide-text">{{ 'button_name.update' | translate }}</span>
        <span *ngIf="!isEdit" class="hide-text">{{ 'button_name.save' | translate }}</span>
    </button>

    <button
        *ngIf="isSaveAndAddOneMore"
        class="display-button"
        mat-raised-button
        color="primary"
        (click)="onSaveAndAddOneMore()">
        <mat-icon>playlist_add</mat-icon>
        <span class="hide-text">{{ 'button_name.save_and_add_one_more' | translate }}</span>
    </button>

    <button class="display-button" mat-raised-button color="primary" (click)="onSaveThen()">
        <mat-icon>playlist_add</mat-icon>
        <span class="hide-text">{{ saveAndThenText }}</span>
    </button>
    <button
        *ngIf="saveThenOtherText"
        class="display-button"
        mat-raised-button
        color="primary"
        (click)="onSaveThenOther()">
        <mat-icon>{{ saveThenOtherIcon || 'check' }}</mat-icon>
        <span class="hide-text">{{ saveThenOtherText | translate }}</span>
    </button>
</div>

<div mat-dialog-actions *ngIf="isManualDeposit">
    <button mat-raised-button color="primary" (click)="onSave()">
        <mat-icon>save</mat-icon>
        <span class="hide-text">{{ saveText }}</span>
    </button>
</div>
